export default [
  {
    key: 'agent_ids',
    value: [],
    label: 'アライアンス名',
    rules: {},
    name: 'agentIds',
    as: 'checkbox',
    options: [],
    checked: [],
    disabled: 1,
  },
  {
    key: 'email',
    value: '',
    label: 'メールアドレス',
    rules: { required: true, email: true },
    name: 'email',
    as: 'input',
  },
  {
    key: 'account_name',
    value: '',
    label: 'ユーザ名',
    rules: { required: true, scope: { min: 1, max: 16 } },
    name: 'accountName',
    as: 'input',
  },
  {
    key: 'password',
    value: '',
    label: 'パスワード',
    rules: { required: false, password: true, confirm: 'passwordConfirm' },
    name: 'password',
    as: 'input',
    type: 'password',
  },
  {
    key: 'password_2',
    value: '',
    label: 'パスワード(確認）',
    rules: { required: false, confirmed: 'password', password: true },
    name: 'passwordConfirm',
    as: 'input',
    type: 'password',
  },
  {
    key: 'gender',
    value: '',
    label: '性別',
    rules: { required: false },
    name: 'gender',
    as: 'radio',
    options: [
      {
        value: '1',
        label: '男性',
      },
      {
        value: '0',
        label: '女性',
      },
    ],
    checked: '',
  },
  {
    key: 'birthday',
    value: '',
    label: '生年月日',
    rules: {},
    name: 'birthday',
    as: 'datepicker',
  },
  {
    key: 'height',
    value: null,
    label: '身長(cm)',
    rules: {},
    name: 'height',
    as: 'input',
    type: 'number',
  },
  {
    key: 'athlete',
    value: '',
    label: 'アスリートモード',
    rules: {},
    name: 'athlete',
    as: 'radio',
    options: [
      {
        value: '0',
        label: 'いいえ',
      },
      {
        value: '1',
        label: 'はい',
      },
    ],
    checked: '',
  },
]
